import keyMirror from 'keymirror';

const SaveButtonConstants = keyMirror({
  NOT_SAVED: null,
  SAVING: null,
  SAVED: null,
});

export default SaveButtonConstants;
